import { Card } from '@cimpress/react-components';
import classNames from 'classnames';
import {
    DocumentPreviewRenderer,
    DocumentUrlPreviewRenderer,
    ImageUrlPreviewRenderer,
    ChildComponentRenderer,
} from './renderers';
import type { PreviewCardProps, PreviewType } from './types';

import classes from './PreviewCard.module.css';

const RENDERERS: Record<PreviewType, any> = {
    document: DocumentPreviewRenderer,
    documentUrl: DocumentUrlPreviewRenderer,
    imageUrl: ImageUrlPreviewRenderer,
    childComponent: ChildComponentRenderer,
    preview3d: ChildComponentRenderer,
};

export const PreviewCard = <T extends PreviewType>({
    title,
    type,
    loader,
    onAgsMetadataLoaded,
    fillWidth = false,
}: PreviewCardProps<T>) => {
    const PreviewRenderer = RENDERERS[type];

    return (
        <Card className={classNames(classes.card, { [classes.fillWidth]: fillWidth })} isMinimal header={title}>
            <PreviewRenderer loader={loader} onAgsMetadataLoaded={onAgsMetadataLoaded} fillWidth={fillWidth} />
        </Card>
    );
};
